import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "screen"
};
const _hoisted_2 = {
  class: "header"
};
const _hoisted_3 = {
  class: "header-date"
};
const _hoisted_4 = {
  class: "main"
};
const _hoisted_5 = {
  class: "census"
};
const _hoisted_6 = {
  class: "census-card rate-total"
};
const _hoisted_7 = {
  class: "content"
};
const _hoisted_8 = {
  class: "rate-item"
};
const _hoisted_9 = {
  class: "number"
};
const _hoisted_10 = {
  class: "census-card card-hot"
};
const _hoisted_11 = {
  class: "content"
};
const _hoisted_12 = {
  class: "title"
};
const _hoisted_13 = {
  class: "card-item"
};
const _hoisted_14 = {
  class: "item-value"
};
const _hoisted_15 = {
  class: "card-item"
};
const _hoisted_16 = {
  class: "item-value"
};
const _hoisted_17 = {
  class: "census-card card-hot"
};
const _hoisted_18 = {
  class: "content"
};
const _hoisted_19 = {
  class: "title"
};
const _hoisted_20 = {
  class: "card-item"
};
const _hoisted_21 = {
  class: "item-value"
};
const _hoisted_22 = {
  class: "card-item"
};
const _hoisted_23 = {
  class: "item-value"
};
const _hoisted_24 = {
  class: "star"
};
const _hoisted_25 = {
  class: "content"
};
const _hoisted_26 = {
  class: "star-item"
};
const _hoisted_27 = {
  class: "star-item-up"
};
const _hoisted_28 = {
  class: "card-item"
};
const _hoisted_29 = {
  class: "item-value"
};
const _hoisted_30 = {
  class: "star-item"
};
const _hoisted_31 = {
  class: "star-item-up"
};
const _hoisted_32 = {
  class: "card-item"
};
const _hoisted_33 = {
  class: "item-value"
};
const _hoisted_34 = {
  class: "star-item"
};
const _hoisted_35 = {
  class: "star-item-up"
};
const _hoisted_36 = {
  class: "card-item"
};
const _hoisted_37 = {
  class: "item-value"
};
const _hoisted_38 = {
  class: "star-item"
};
const _hoisted_39 = {
  class: "star-item-up"
};
const _hoisted_40 = {
  class: "card-item"
};
const _hoisted_41 = {
  class: "item-value"
};
const _hoisted_42 = {
  class: "opinion"
};
const _hoisted_43 = {
  class: "item-info"
};
const _hoisted_44 = {
  class: "item-info-date"
};
const _hoisted_45 = {
  class: "p"
};
import { ref, onMounted, onUnmounted, nextTick } from 'vue';
import { getStatisticData, getRateList } from '@/api/index';
import CardHeader from './CardHeader.vue';
export default {
  __name: 'index',
  setup(__props) {
    onMounted(() => {
      screenScale();
      getStatisticInfo();
      homeRateList();
      apiTime();
      getDateFn();
    });
    onUnmounted(() => {
      if (apiTimeNumber.value) clearTimeout(apiTimeNumber.value);
      if (opinionTime.value) clearInterval(opinionTime.value);
    });

    // 等比例缩放网页
    let scallWrap = ref();
    function screenScale() {
      let ele = scallWrap.value;
      // 1.设计稿尺寸
      let targetWidth = 1920;
      let targetHeight = 1080;
      let targetRatio = 16 / 9; // 宽高比率 （宽 / 高）

      // 2.拿到当前设备（浏览器）的宽度
      let currentWidth = document.documentElement.clientWidth || document.body.clientWidth;
      let currentHeight = document.documentElement.clientHeight || document.body.clientHeight;
      // 3.计算缩放比率(屏幕过宽，根据高度计算缩放比例)
      let scaleRatio = currentWidth / targetWidth; // 参照宽度进行缩放（默认情况下）

      // 当前宽高比例
      let currentRatio = currentWidth / currentHeight;
      if (currentRatio > targetRatio) {
        scaleRatio = currentHeight / targetHeight; // 参照高度进行缩放（屏幕很宽的情况下）
        ele.style = `transform: scale(${scaleRatio}) translateX(-50%); left: 50%;`;
      } else {
        // 4.开始缩放网页
        ele.style = `transform: scale(${scaleRatio})`;
      }
    }

    // 预警处理滚动
    let opinionTop = ref(0);
    let opinionList = ref([]);
    let opinionTime = ref();
    let boxRef = ref();
    let itemRef = ref();
    function animationFn() {
      let boxHeight = boxRef.value.offsetHeight;
      let itemHeight = itemRef.value.offsetHeight;
      if (itemHeight > boxHeight) {
        opinionList.value = opinionList.value.concat(opinionList.value);
        if (opinionTime.value) clearInterval(opinionTime.value);
        opinionTime.value = setInterval(() => {
          let topNumber = Math.abs(opinionTop.value);
          if (topNumber > itemHeight / 2) {
            opinionTop.value = topNumber - itemHeight / 2;
          } else {
            opinionTop.value = opinionTop.value + 1;
          }
        }, 20);
      }
    }
    // 统一请求
    let apiTimeNumber = ref();
    function apiTime() {
      apiTimeNumber.value = setTimeout(() => {
        getStatisticInfo();
        if (opinionTime.value) clearInterval(opinionTime.value);
        homeRateList();
        apiTime();
      }, 60000);
    }
    // API 获取统计数据
    let censusData = ref({});
    function getStatisticInfo() {
      getStatisticData().then(data => {
        censusData.value = data;
      });
    }
    // API 获取评价列表
    function homeRateList() {
      getRateList(10).then(data => {
        let dataList = data || [];
        opinionList.value = dataList.map(item => {
          return {
            id: item.id,
            date: item.evaluationTime.toString().replace(/-/g, '.'),
            desc: item.suggestionDescribe
          };
        });
        opinionTop.value = 0;
        nextTick(() => {
          animationFn();
        });
      });
    }
    // 获取当前日期
    let currentDate = ref('');
    function getDateFn() {
      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      month = month > 9 ? month : '0' + month;
      day = day > 9 ? day : '0' + day;
      currentDate.value = `${year}年${month}月${day}日`;
    }
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "screen-wrap",
        ref_key: "scallWrap",
        ref: scallWrap
      }, [_createElementVNode("div", _hoisted_2, [_cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "header-title"
      }, "满意度统计", -1)), _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(currentDate)), 1)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "subtitle"
      }, "总体满意度", -1)), _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(censusData).totalEvaluationSatisfaction) + "% ", 1), _cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "title"
      }, null, -1)), _createVNode(_component_el_image, {
        class: "img",
        src: require('@/assets/images/screen/history_rate.png'),
        fit: "fill"
      }, null, 8, ["src"])])])]), _createElementVNode("div", _hoisted_10, [_createVNode(CardHeader, {
        title: "历史热点"
      }), _createElementVNode("div", _hoisted_11, [_createVNode(_component_el_image, {
        class: "img",
        src: require('@/assets/images/screen/history_hot.png'),
        fit: "fill"
      }, null, 8, ["src"]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_12, _toDisplayString(_unref(censusData).historyHotName), 1), _createElementVNode("div", _hoisted_13, [_cache[3] || (_cache[3] = _createElementVNode("div", {
        class: "item-label"
      }, "总评价次数", -1)), _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(censusData).historyHotEvaluationTotalTimes), 1)]), _createElementVNode("div", _hoisted_15, [_cache[4] || (_cache[4] = _createElementVNode("p", {
        class: "item-label"
      }, "满意度", -1)), _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(censusData).historyHotEvaluationSatisfaction) + "% ", 1)])])])]), _createElementVNode("div", _hoisted_17, [_createVNode(CardHeader, {
        title: "今日热点"
      }), _createElementVNode("div", _hoisted_18, [_createVNode(_component_el_image, {
        class: "img",
        src: require('@/assets/images/screen/history_hot.png'),
        fit: "fill"
      }, null, 8, ["src"]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_19, _toDisplayString(_unref(censusData).todayHotName), 1), _createElementVNode("div", _hoisted_20, [_cache[5] || (_cache[5] = _createElementVNode("div", {
        class: "item-label"
      }, "今日评价", -1)), _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(censusData).todayHotEvaluationTotalTimes), 1)]), _createElementVNode("div", _hoisted_22, [_cache[6] || (_cache[6] = _createElementVNode("p", {
        class: "item-label"
      }, "满意度", -1)), _createElementVNode("div", _hoisted_23, _toDisplayString(_unref(censusData).todayHotEvaluationSatisfaction) + "% ", 1)])])])])]), _createElementVNode("div", _hoisted_24, [_createVNode(CardHeader, {
        title: "满意度"
      }), _createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_createVNode(_component_el_image, {
        class: "img",
        src: require('@/assets/images/screen/icon_star.png'),
        fit: "fill"
      }, null, 8, ["src"]), _createElementVNode("div", null, [_cache[8] || (_cache[8] = _createElementVNode("div", {
        class: "title"
      }, "饭菜质量", -1)), _createElementVNode("div", _hoisted_28, [_cache[7] || (_cache[7] = _createElementVNode("div", {
        class: "item-label"
      }, "满意度", -1)), _createElementVNode("div", _hoisted_29, _toDisplayString(_unref(censusData).foodQualitySatisfaction) + "% ", 1)])])]), _cache[9] || (_cache[9] = _createElementVNode("div", {
        class: "line"
      }, null, -1))]), _createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [_createVNode(_component_el_image, {
        class: "img",
        src: require('@/assets/images/screen/icon_star.png'),
        fit: "fill"
      }, null, 8, ["src"]), _createElementVNode("div", null, [_cache[11] || (_cache[11] = _createElementVNode("div", {
        class: "title"
      }, "食品卫生", -1)), _createElementVNode("div", _hoisted_32, [_cache[10] || (_cache[10] = _createElementVNode("div", {
        class: "item-label"
      }, "满意度", -1)), _createElementVNode("div", _hoisted_33, _toDisplayString(_unref(censusData).foodHygieneSatisfaction) + "% ", 1)])])]), _cache[12] || (_cache[12] = _createElementVNode("div", {
        class: "line"
      }, null, -1))]), _createElementVNode("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, [_createVNode(_component_el_image, {
        class: "img",
        src: require('@/assets/images/screen/icon_star.png'),
        fit: "fill"
      }, null, 8, ["src"]), _createElementVNode("div", null, [_cache[14] || (_cache[14] = _createElementVNode("div", {
        class: "title"
      }, "服务态度", -1)), _createElementVNode("div", _hoisted_36, [_cache[13] || (_cache[13] = _createElementVNode("div", {
        class: "item-label"
      }, "满意度", -1)), _createElementVNode("div", _hoisted_37, _toDisplayString(_unref(censusData).serviceAttitudeSatisfaction) + "% ", 1)])])]), _cache[15] || (_cache[15] = _createElementVNode("div", {
        class: "line"
      }, null, -1))]), _createElementVNode("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, [_createVNode(_component_el_image, {
        class: "img",
        src: require('@/assets/images/screen/icon_star.png'),
        fit: "fill"
      }, null, 8, ["src"]), _createElementVNode("div", null, [_cache[17] || (_cache[17] = _createElementVNode("div", {
        class: "title"
      }, "就餐环境", -1)), _createElementVNode("div", _hoisted_40, [_cache[16] || (_cache[16] = _createElementVNode("div", {
        class: "item-label"
      }, "满意度", -1)), _createElementVNode("div", _hoisted_41, _toDisplayString(_unref(censusData).diningEnvironmentSatisfaction) + "% ", 1)])])]), _cache[18] || (_cache[18] = _createElementVNode("div", {
        class: "line"
      }, null, -1))])])]), _createElementVNode("div", _hoisted_42, [_createVNode(CardHeader, {
        class: "opinion-header",
        title: "评价建议"
      }), _createElementVNode("div", {
        class: "opinion-content",
        ref_key: "boxRef",
        ref: boxRef
      }, [_createElementVNode("div", {
        class: "items",
        ref_key: "itemRef",
        ref: itemRef,
        style: _normalizeStyle({
          top: -_unref(opinionTop) + 'px'
        })
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(opinionList), item => {
        return _openBlock(), _createElementBlock("div", {
          class: "item",
          key: item.id
        }, [_createVNode(_component_el_image, {
          class: "img",
          src: require('@/assets/images/screen/icon_opinion.png'),
          fit: "fill"
        }, null, 8, ["src"]), _createElementVNode("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, _toDisplayString(item.date), 1), _createElementVNode("div", _hoisted_45, _toDisplayString(item.desc), 1)])]);
      }), 128))], 4)], 512)])])], 512)]);
    };
  }
};